<template>
  <div ref="card" class="audio-player" data-theme="dark">
    <audio ref="metadata" :src="src" preload="metadata" />

    <AudioPlayerPanel />
  </div>
</template>

<script setup lang="ts">
  /*=== Import ===*/
  import { AudioPlayerPanel } from './ui';
  import { useAudioPlayerModel } from './model';
  import type { AudioPlayerProps } from './types';

  const props = defineProps<AudioPlayerProps>();

  useAudioPlayerModel(props);
</script>

<style lang="scss" scoped>
  @use './style.scss';
</style>
